import {
  GetCreateReservationAvailabilityOptionsQuery,
  GetCreateReservationAvailabilityOptionsQueryVariables,
} from '@data/__generated__/types.reservations'
import {gql, useQuery} from 'apollo-hooks'

import dayjs from 'dayjs'

export function useAvailabilityOptions({
  date,
  storeOptions,
  partySize,
  dateHour,
  dateDay,
  sectorId,
}) {
  const dateParam = `${dayjs(dateDay).tz(storeOptions.timezone).format('YYYY-MM-DD')}T${dateHour}:00${dayjs()
    .tz(storeOptions.timezone)
    .format('Z')}`
  const {data, loading} = useQuery<
    GetCreateReservationAvailabilityOptionsQuery,
    GetCreateReservationAvailabilityOptionsQueryVariables
  >({
    clientName: 'reservations',
    query: gql`
      query getCreateReservationAvailabilityOptions(
        $storeId: String
        $date: Date
        $partySize: Float
      ) {
        sectors: storeSectors(storeId: $storeId) {
          _id
          name
          disabledForReservations
        }
        options: availabilityOptions(storeId: $storeId, date: $date, partySize: $partySize, limit: 5, maxDiffMinutes: 360) {
          date
          label
          sectorIds
          availableTableOptions {
            label
            tableIds
            sectorId
          }
        }
      }
    `,
    variables: {
      storeId: storeOptions._id,
      date: dateParam,
      partySize,
    },
    omit: !storeOptions._id || !dateDay || !dateHour || !partySize,
    fetchPolicy: 'cache-and-network',
    partial: true,
  })

  const sectors = data?.sectors ?? []
  const options = data?.options ?? []

  const selectedOption =
    sectorId &&
    options
      .filter(option => option.sectorIds.includes(sectorId))
      .filter(option => {
        return option.sectorIds.includes(sectorId)
      })
      .find(option => {
        return dayjs(option.date).isSame(dayjs(date), 'minute')
      })

  return {
    loading,
    options: sectors.map(sector => {
      return {
        sector,
        dates: options.filter(option => option.sectorIds.includes(sector._id)),
      }
    }),
    selectedOption,
  }
}
